"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cccisdReactRouter = require("cccisd-react-router");
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil7"));
var _play = _interopRequireDefault(require("cccisd-icons/play4"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner11"));
var _medal = _interopRequireDefault(require("cccisd-icons/medal"));
var _book = _interopRequireDefault(require("cccisd-icons/book3"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
var _useCourseWrapperMediator = _interopRequireDefault(require("./useCourseWrapperMediator"));
var _useOverlayBgStyles = _interopRequireDefault(require("./useOverlayBgStyles"));
var _index = _interopRequireDefault(require("./Certificate/index.js"));
var _CourseDescription = _interopRequireDefault(require("./CourseDescription"));
var _index2 = _interopRequireDefault(require("./CurriculumTabs/index.js"));
var _DeploymentPlayer = _interopRequireDefault(require("../../../DeploymentPlayer"));
var _InvokeSubMediator = _interopRequireDefault(require("./InvokeSubMediator"));
var _RepeatedFinalTest = _interopRequireDefault(require("./RepeatedFinalTest"));
var _Resources = _interopRequireDefault(require("./Resources"));
var _Tab = _interopRequireDefault(require("./Tab"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CourseWrapperMediator = function CourseWrapperMediator(props) {
  var history = (0, _cccisdReactRouter.useHistory)();
  var modalRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (modalRef && modalRef.current) modalRef.current.open();
  }, [modalRef.current]);
  var mediatorProps = props.mediatorProps;
  var certificate = mediatorProps.certificate,
    course = mediatorProps.course,
    courseDescription = mediatorProps.courseDescription,
    finalTest = mediatorProps.finalTest,
    registration = mediatorProps.registration,
    courseEval = mediatorProps.courseEval,
    resources = mediatorProps.resources,
    setIsShowingLayoutBgColor = mediatorProps.setIsShowingLayoutBgColor,
    renderCourseInOverlay = mediatorProps.renderCourseInOverlay,
    modalHeaderImageUrl = mediatorProps.modalHeaderImageUrl,
    modalHeaderImageFileName = mediatorProps.modalHeaderImageFileName,
    currentLayout = mediatorProps.currentLayout,
    topHeader = mediatorProps.topHeader;
  var _useCourseWrapperMedi = (0, _useCourseWrapperMediator["default"])(_objectSpread(_objectSpread({}, props), {}, {
      originalFlowList: props.flowList
    })),
    availableTabs = _useCourseWrapperMedi.availableTabs,
    currentTabs = _useCourseWrapperMedi.currentTabs,
    currTab = _useCourseWrapperMedi.currTab,
    curriculumProps = _useCourseWrapperMedi.curriculumProps,
    flowList = _useCourseWrapperMedi.flowList,
    isCourseComplete = _useCourseWrapperMedi.isCourseComplete,
    isCourseEvalComplete = _useCourseWrapperMedi.isCourseEvalComplete,
    isFinalTestComplete = _useCourseWrapperMedi.isFinalTestComplete,
    isLoading = _useCourseWrapperMedi.isLoading,
    isRegistrationComplete = _useCourseWrapperMedi.isRegistrationComplete,
    isRepeatedFinalTest = _useCourseWrapperMedi.isRepeatedFinalTest,
    isTabMediatorComplete = _useCourseWrapperMedi.isTabMediatorComplete,
    latestFinalTestData = _useCourseWrapperMedi.latestFinalTestData,
    mediatorTabData = _useCourseWrapperMedi.mediatorTabData,
    onClickTab = _useCourseWrapperMedi.onClickTab,
    onExternalRegistrationComplete = _useCourseWrapperMedi.onExternalRegistrationComplete,
    onFinalTestComplete = _useCourseWrapperMedi.onFinalTestComplete,
    onFlowCompleteLocal = _useCourseWrapperMedi.onFlowCompleteLocal,
    onFlowStartedLocal = _useCourseWrapperMedi.onFlowStartedLocal,
    relatedDeploymentId = _useCourseWrapperMedi.relatedDeploymentId,
    setFlowList = _useCourseWrapperMedi.setFlowList,
    showExternalRegistrationDeployment = _useCourseWrapperMedi.showExternalRegistrationDeployment;
  var overlayBgStyles = (0, _useOverlayBgStyles["default"])(currentLayout, setIsShowingLayoutBgColor);
  var renderTabs = function renderTabs() {
    if (!availableTabs.filter(function (tabName) {
      return !['course', 'registration'].includes(tabName);
    }).length) {
      return null;
    }

    // for curriculum navigation, "course" tab is considered Home
    if (course.isCurriculum && course.curriculumTabStyle === 'side') {
      return /*#__PURE__*/_react["default"].createElement(_index2["default"], _extends({}, props, {
        currentTabs: currentTabs,
        currTab: currTab,
        curriculumProps: curriculumProps
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].topBar
    }, /*#__PURE__*/_react["default"].createElement("div", {
      role: "navigation",
      className: "btn-group btn-group-justified"
    }, currentTabs.filter(function (tab) {
      return renderCourseInOverlay ? tab !== 'courseDescription' : tab;
    }).map(function (tabKey) {
      return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
        currTab: currTab,
        key: tabKey,
        mediatorProps: mediatorProps,
        onClickTab: onClickTab,
        tabKey: tabKey
      });
    })));
  };
  var subMediatorTabs = ['course', 'courseEval'];
  if (!isRepeatedFinalTest) {
    subMediatorTabs.push('finalTest');
  }
  if (!showExternalRegistrationDeployment) {
    subMediatorTabs.push('registration');
  }
  var isSubMediator = subMediatorTabs.includes(currTab);
  // whenever component mounts or changes, see if we should toggle background
  (0, _react.useEffect)(function () {
    if (setIsShowingLayoutBgColor) {
      setIsShowingLayoutBgColor(!renderCourseInOverlay && !!(isSubMediator || currTab === 'registration' && showExternalRegistrationDeployment));
    }
    setFlowList(flowList.map(function (f) {
      delete f.completedLocally;
      return f;
    }));
  }, [currTab]);
  var subMediatorSettings = _objectSpread({}, mediatorProps[currTab]);
  if (course.isCurriculum && currTab === 'course' && curriculumProps) {
    subMediatorSettings.navigationSettings = curriculumProps;
  }
  var buttons = function buttons() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].buttons
    }, !isRegistrationComplete && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-warning",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/registration"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], {
      spaceRight: true
    }), "Register"), isRegistrationComplete && !isCourseComplete && !flowList.some(function (fl) {
      return fl.isStarted;
    }) && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/course"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_play["default"], {
      spaceRight: true
    }), "Start"), isRegistrationComplete && !isCourseComplete && flowList.some(function (fl) {
      return fl.isStarted;
    }) && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-success",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/course"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_play["default"], {
      spaceRight: true
    }), "Continue"), isCourseComplete && !isFinalTestComplete && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, course.allowRetake && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-info",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/course"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], {
      spaceRight: true
    }), "Review Course"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-success",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/finalTest"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_play["default"], {
      spaceRight: true
    }), course.allowRetake ? (finalTest === null || finalTest === void 0 ? void 0 : finalTest.tabName) || 'Assessment' : 'Continue')), isCourseComplete && isFinalTestComplete && !isCourseEvalComplete && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, course.allowRetake && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-info",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/course"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], {
      spaceRight: true
    }), "Review Course"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-success",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/courseEval"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_play["default"], {
      spaceRight: true
    }), course.allowRetake ? (courseEval === null || courseEval === void 0 ? void 0 : courseEval.tabName) || 'Course Evaluation' : 'Continue')), isCourseComplete && isFinalTestComplete && isCourseEvalComplete && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, course.allowRetake && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-info",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/course"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], {
      spaceRight: true
    }), "Review Course"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/certificate"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_medal["default"], {
      spaceRight: true
    }), "Certificate")), resources.toggle && (resources.lockedUntilCompletion ? isCourseComplete && isFinalTestComplete && isCourseEvalComplete : true) && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-info",
      onClick: function onClick() {
        history.push("".concat(props.basePath, "/resources"));
      }
    }, /*#__PURE__*/_react["default"].createElement(_book["default"], {
      spaceRight: true
    }), "Resources"));
  };
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  if (renderCourseInOverlay) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].modalContent
    }, currTab === 'courseDescription' ? /*#__PURE__*/_react["default"].createElement(_CourseDescription["default"], {
      settings: courseDescription,
      buttons: buttons
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      bodyStyle: isSubMediator || currTab === 'registration' && showExternalRegistrationDeployment ? overlayBgStyles.style || {} : {},
      ref: modalRef,
      modalClassName: _style["default"].courseWrapperInOverlayModal,
      afterClose: function afterClose() {
        return history.push("".concat(props.basePath, "/courseDescription"));
      },
      title: modalHeaderImageFileName ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: "<img src=\"".concat(modalHeaderImageUrl, "\" alt=\"").concat(modalHeaderImageFileName, "\" height=\"36\" data-image=\"980\" />")
      }) : ''
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-cccisd-survey-area": true,
      style: {
        maxWidth: '1200px',
        flexGrow: 1
      }
    }, isSubMediator && /*#__PURE__*/_react["default"].createElement(_InvokeSubMediator["default"], _extends({}, props, mediatorTabData[currTab], {
      key: currTab,
      flowList: flowList.filter(function (f) {
        return mediatorProps[currTab].options.includes(f.handle);
      }),
      onFlowComplete: onFlowCompleteLocal,
      onFlowStarted: onFlowStartedLocal,
      settings: subMediatorSettings
    })), currTab === 'registration' && showExternalRegistrationDeployment && /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], _extends({}, props, {
      pawnHash: props.actingPawnHash,
      pawnId: props.actingPawnId,
      deploymentId: Number(registration.externalRegistrationDeploymentId),
      disableLayout: true,
      onComplete: onExternalRegistrationComplete
    })), currTab === 'finalTest' && isRepeatedFinalTest && /*#__PURE__*/_react["default"].createElement(_RepeatedFinalTest["default"], _extends({}, props, mediatorTabData[currTab], {
      latestFinalTestData: latestFinalTestData,
      onComplete: onFinalTestComplete,
      relatedDeploymentId: relatedDeploymentId,
      settings: finalTest
    })), currTab === 'certificate' && /*#__PURE__*/_react["default"].createElement(_index["default"], _extends({}, props, {
      deploymentId: flowList.length ? flowList[0].responseSet : '',
      hide: !isCourseComplete || !isTabMediatorComplete('finalTest') || !isTabMediatorComplete('courseEval'),
      latestFinalTestData: latestFinalTestData,
      settings: certificate
    })), currTab === 'resources' && /*#__PURE__*/_react["default"].createElement(_Resources["default"], {
      settings: resources,
      isCourseComplete: isCourseComplete
    }))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, topHeader && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: topHeader
  }), renderTabs(), currTab === 'courseDescription' && /*#__PURE__*/_react["default"].createElement(_CourseDescription["default"], {
    settings: courseDescription
  }), isSubMediator && /*#__PURE__*/_react["default"].createElement(_InvokeSubMediator["default"], _extends({}, props, mediatorTabData[currTab], {
    key: currTab,
    flowList: flowList.filter(function (f) {
      return mediatorProps[currTab].options.includes(f.handle);
    }),
    onFlowComplete: onFlowCompleteLocal,
    onFlowStarted: onFlowStartedLocal,
    settings: subMediatorSettings
  })), currTab === 'registration' && showExternalRegistrationDeployment && /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], _extends({}, (0, _omit2["default"])(props, ['flowList']), {
    pawnHash: props.actingPawnHash,
    pawnId: props.actingPawnId,
    deploymentId: Number(registration.externalRegistrationDeploymentId),
    disableLayout: true,
    onComplete: onExternalRegistrationComplete
  })), currTab === 'finalTest' && isRepeatedFinalTest && /*#__PURE__*/_react["default"].createElement(_RepeatedFinalTest["default"], _extends({}, props, mediatorTabData[currTab], {
    latestFinalTestData: latestFinalTestData,
    onComplete: onFinalTestComplete,
    relatedDeploymentId: relatedDeploymentId,
    settings: finalTest
  })), currTab === 'certificate' && /*#__PURE__*/_react["default"].createElement(_index["default"], _extends({}, props, {
    deploymentId: flowList.length ? flowList[0].responseSet : '',
    hide: !isCourseComplete || !isTabMediatorComplete('finalTest') || !isTabMediatorComplete('courseEval'),
    latestFinalTestData: latestFinalTestData,
    settings: certificate
  })), currTab === 'resources' && /*#__PURE__*/_react["default"].createElement(_Resources["default"], {
    settings: resources,
    isCourseComplete: isCourseComplete
  }));
};
CourseWrapperMediator.propTypes = {
  actingPawnHash: _propTypes["default"].string,
  actingPawnId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  basePath: _propTypes["default"].string,
  flowList: _propTypes["default"].array.isRequired,
  isPreviewMode: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  mediatorProps: _propTypes["default"].object,
  onAssignmentComplete: _propTypes["default"].func,
  onComplete: _propTypes["default"].func,
  onFlowComplete: _propTypes["default"].func,
  onFlowStarted: _propTypes["default"].func,
  onModuleComplete: _propTypes["default"].func
};
var _default = CourseWrapperMediator;
exports["default"] = _default;